import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Loader2, ShieldCheck } from "lucide-react";
import { api, fmtErr } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AdminLogin() {
  const [form, setForm] = useState({ email: "", password: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const { setUser } = useAuth();
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login?admin=true", { ...form, remember: true });
      setUser(data);
      toast.success("Welcome, Admin");
      navigate("/admin");
    } catch (err) {
      setError(fmtErr(err, "Admin login failed"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-slate-900 flex items-center justify-center px-4 py-12">
      <div className="w-full max-w-md">
        <div className="flex items-center justify-center gap-2.5 mb-8">
          <div className="w-10 h-10 rounded-xl bg-blue-600 flex items-center justify-center">
            <ShieldCheck className="w-6 h-6 text-white" />
          </div>
          <div className="leading-tight">
            <span className="block font-heading font-bold text-white text-lg">Equinox 4 Review</span>
            <span className="block text-[11px] font-medium text-slate-400 tracking-wider">ADMIN PORTAL</span>
          </div>
        </div>
        <div className="bg-white rounded-2xl shadow-xl p-6 sm:p-8" data-testid="admin-login-card">
          <h1 className="text-2xl font-bold font-heading text-slate-900">Admin Login</h1>
          <p className="mt-1.5 text-sm text-slate-600">Restricted access. Authorised administrators only.</p>
          {error && <div data-testid="admin-login-error" className="mt-4 text-sm text-red-700 bg-red-50 border border-red-200 rounded-xl px-4 py-3">{error}</div>}
          <form onSubmit={submit} className="mt-6 space-y-4">
            <div>
              <label className="block text-sm font-medium text-slate-700 mb-1.5">Admin email</label>
              <input data-testid="admin-email-input" type="email" required value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })}
                className="w-full rounded-xl border border-slate-300 px-4 py-3 text-base focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="admin@equinox4review.in" />
            </div>
            <div>
              <label className="block text-sm font-medium text-slate-700 mb-1.5">Password</label>
              <input data-testid="admin-password-input" type="password" required value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })}
                className="w-full rounded-xl border border-slate-300 px-4 py-3 text-base focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="••••••••" />
            </div>
            <button type="submit" data-testid="admin-login-submit-btn" disabled={loading}
              className="w-full inline-flex items-center justify-center gap-2 px-6 py-3.5 rounded-xl font-semibold text-white bg-slate-900 hover:bg-slate-800 disabled:opacity-60 transition-colors">
              {loading && <Loader2 className="w-4 h-4 animate-spin" />} Login to Admin Panel
            </button>
          </form>
          <div className="mt-5 pt-4 border-t border-slate-100 text-center">
            <Link to="/login" data-testid="user-portal-link" className="inline-flex items-center gap-1.5 text-xs font-semibold text-slate-500 hover:text-slate-800 transition-colors">
              ← Not an admin? Back to user login
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
